import { useQuery, type UseQueryResult } from '@tanstack/react-query'

import { getMemberInsightCategories } from 'src/app/home/adapters'
import { memberInsightsKeys } from 'src/app/home/queries/member-insights-keys'

const ONE_HOUR_MS = 60 * 60 * 1000

export interface IUseMemberInsightCategoriesQueryParams {
  enabled: boolean
}

export const useMemberInsightCategoriesQuery = (
  params: IUseMemberInsightCategoriesQueryParams,
): UseQueryResult<string[], Error> => {
  return useQuery({
    queryKey: memberInsightsKeys.categories(),
    meta: { silent: true },
    staleTime: ONE_HOUR_MS,
    queryFn: async (): Promise<string[]> => {
      const response = await getMemberInsightCategories()
      return response.categories
    },
    enabled: params.enabled,
  })
}
